import React from 'react';
import { Table, Typography } from 'antd';

const { Title } = Typography;

export const InstalledSoftwareTable = ({ programs = [] }) => {
    if (!programs || programs.length === 0) return null;

    return (
        <div className="inventory-section">
            <Title level={5}>Installed Software</Title>
            <Table
                size="small"
                pagination={false}
                dataSource={programs}
                columns={[
                    { title: 'Name', dataIndex: 'display_name', key: 'display_name' },
                    { title: 'Vendor', dataIndex: 'publisher', key: 'publisher' },
                    { title: 'Version', dataIndex: 'display_version', key: 'display_version' },
                ]}
                rowKey={(item) =>
                    `software-${item.display_name || ''}-${item.display_version || ''}-${item.publisher || ''}`
                }
            />
        </div>
    );
};

export default InstalledSoftwareTable;
